import dayjs from 'dayjs';
import 'dayjs/locale/de';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.locale('en-GB'); // todo - remove this and format dates based on user's Strava location/date format preferences
dayjs.extend(advancedFormat);

export default dayjs;
